import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface PrePlanState extends ListState<any> {
    stockmodel: any;
    id: number;
}

class PrePlanMutations extends ListMutations<any> {
}

class FrontPrePlan extends ListModule<PrePlanState, any, any> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        stockmodel: {} as any,
        id: 0
    }

    actions = {
        // ��ȡԤ���ƻ��б�
        async getAll(context: ActionContext<PrePlanState, any>, payload: any) {
            context.state.loading = true;
            const response = await Ajax.get('/api/services/app/UserPrePlan/GetList', { params: payload.data });
            context.state.loading = false;
            const page = response.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },

        // ����/�༭Ԥ���ƻ�
        async create(context: ActionContext<PrePlanState, any>, payload: any) {
            await Ajax.post('/api/services/app/UserPrePlan/Create', payload.data);
        },

        // ɾ��Ԥ���ƻ�
        async delete(context: ActionContext<PrePlanState, any>, payload: any) {
            await Ajax.post(`/api/services/app/UserPrePlan/Delete?id=${payload.data.id}`);
        }
    };

    mutations = {
        setCurrentPage(state: PrePlanState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: PrePlanState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setModel(state: PrePlanState, model: any) {
            state.stockmodel = model;
        }
    }
}

const frontPrePlan = new FrontPrePlan();
export default frontPrePlan;